// EmployeeActionTypes.ts
export const EMPLOYEE_GET_ALL = "EMPLOYEE_GET_ALL";
export const EMPLOYEE_SET_FILTERS = "EMPLOYEE_SET_FILTERS";
export const EMPLOYEE_CLEAR_FILTERS = "EMPLOYEE_CLEAR_FILTERS";
export const EMPLOYEE_SET_STATE = "EMPLOYEE_SET_STATE";
export const EMPLOYEE_PAGE_RESET = "EMPLOYEE_PAGE_RESET";
export const EMPLOYEE_SET_LOADING = "EMPLOYEE_SET_LOADING";
export const EMPLOYEE_SET_ERROR = "EMPLOYEE_SET_ERROR";
export const EMPLOYEE_CLEAR_ERROR = "EMPLOYEE_CLEAR_ERROR";
export const EMPLOYEE_DETAILS_SUCCESS = "EMPLOYEE_DETAILS_SUCCESS";
export const EMPLOYEE_DETAILS_FAILURE = "EMPLOYEE_DETAILS_FAILURE";
export const EMPLOYEE_DETAILS_RESET = "EMPLOYEE_DETAILS_RESET";
export const EMPLOYEE_SET_SELECTED = "EMPLOYEE_SET_SELECTED";
export const EMPLOYEE_MANAGE_REQUEST = "EMPLOYEE_MANAGE_REQUEST";
export const EMPLOYEE_MANAGE_SUCCESS = "EMPLOYEE_MANAGE_SUCCESS";
export const EMPLOYEE_MANAGE_FAILURE = "EMPLOYEE_MANAGE_FAILURE";
// Add these to your LeaveActionType.ts exports
export const LEAVE_FINAL_APPROVER_REQUEST = "LEAVE_FINAL_APPROVER_REQUEST";
export const LEAVE_FINAL_APPROVER_SUCCESS = "LEAVE_FINAL_APPROVER_SUCCESS";
export const LEAVE_FINAL_APPROVER_FAILURE = "LEAVE_FINAL_APPROVER_FAILURE";